import { useEffect, useState } from 'react'
import { Menu } from 'antd'
import {
	BookOutlined,
	FontColorsOutlined,
	HomeOutlined,
	UserOutlined,
	WechatOutlined,
	NotificationOutlined,
	PictureOutlined,
	DeploymentUnitOutlined,
	MailOutlined,
	RobotOutlined,
	ReadOutlined,
	FileTextOutlined,
	GlobalOutlined,
	TagOutlined,
} from '@ant-design/icons'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Logo from '../../assests/images/logo.png'
import { ROUTE } from '../../utils/constant'
import './Sidebar.scss'

export const MENU_ITEM = [
	{
		title: 'User Management',
		icon: <UserOutlined />,
		href: `${ROUTE.USER_MANAGEMENT}`,
		sub: [
			// {
			// 	title: 'Overview',
			// 	href: `${ROUTE.USER_MANAGEMENT}${ROUTE.OVERVIEW}`,
			// },
			{
				title: 'Users',
				href: `${ROUTE.USER_MANAGEMENT}${ROUTE.LIST}`,
			},
			{
				title: 'Chat engagement',
				href: `${ROUTE.USER_MANAGEMENT}${ROUTE.CHAT_ENGAGEMENT}`,
			},
		],
	},
	{
		title: 'Word Management',
		icon: <FontColorsOutlined />,
		href: `${ROUTE.WORD_MANAGEMENT}`,
		sub: [
			// {
			// 	title: 'Overview',
			// },
			{
				title: 'Words saved',
				href: `${ROUTE.WORD_MANAGEMENT}${ROUTE.LIST}`,
			},
			// {
			// 	title: 'Words learned',
			// },
		],
	},
	{
		title: 'Dictionary Management',
		icon: <BookOutlined />,
		href: `${ROUTE.DICTIONARY_MANAGEMENT}`,
		sub: [
			{
				title: 'Word Types',
				href: `${ROUTE.DICTIONARY_MANAGEMENT}${ROUTE.WORD_TYPES}`,
			},
			{
				title: 'Dict',
				href: `${ROUTE.DICTIONARY_MANAGEMENT}${ROUTE.LIST}`,
			},
		],
	},
	{
		title: 'Voucher Management',
		icon: <TagOutlined />,
		href: `${ROUTE.VOUCHER_MANAGEMENT}`,
		sub: [
			{
				title: 'Vouchers',
				href: `${ROUTE.VOUCHER_MANAGEMENT}${ROUTE.LIST}`,
			},
		],
	},
	{
		title: 'Order Management',
		icon: <WechatOutlined />,
		href: `${ROUTE.ORDER_MANAGEMENT}`,
		sub: [
			{
				title: 'Order',
				href: `${ROUTE.ORDER_MANAGEMENT}${ROUTE.LIST}`,
			},
		],
	},
	{
		title: 'Feedback Management',
		icon: <WechatOutlined />,
		href: `${ROUTE.FEEDBACK_MANAGEMENT}`,
		sub: [
			// {
			// 	title: 'Overview',
			// },
			{
				title: 'Feedbacks',
				href: `${ROUTE.FEEDBACK_MANAGEMENT}${ROUTE.LIST}`,
			},
			{
				title: 'Reports',
				href: `${ROUTE.FEEDBACK_MANAGEMENT}${ROUTE.REPORT}`,
			},
		],
	},
	{
		title: 'Release Management',
		icon: <DeploymentUnitOutlined />,
		href: `${ROUTE.RELEASE_MANAGEMENT}`,
		sub: [
			{
				title: 'Lists',
				href: `${ROUTE.RELEASE_MANAGEMENT}${ROUTE.LIST}`,
			},
			{
				title: 'Create',
				href: `${ROUTE.RELEASE_MANAGEMENT}${ROUTE.CREATE}`,
			},
		],
	},
	{
		title: 'Notification Management',
		icon: <NotificationOutlined />,
		href: `${ROUTE.NOTIFICATION_MANAGEMENT}`,
		sub: [
			{
				title: 'Lists',
				href: `${ROUTE.NOTIFICATION_MANAGEMENT}${ROUTE.LIST}`,
			},
			{
				title: 'Send',
				href: `${ROUTE.NOTIFICATION_MANAGEMENT}${ROUTE.NOTIFICATION_SEND}`,
			},
		],
	},
	{
		title: 'Product Announcements',
		icon: <PictureOutlined />,
		href: `${ROUTE.ANNOUNCEMENT_MANAGEMENT}`,
		sub: [
			{
				title: 'Lists',
				href: `${ROUTE.ANNOUNCEMENT_MANAGEMENT}${ROUTE.LIST}`,
			},
			{
				title: 'Create',
				href: `${ROUTE.ANNOUNCEMENT_MANAGEMENT}${ROUTE.CREATE}`,
			},
		],
	},
	{
		title: 'Course Management',
		icon: <ReadOutlined />,
		href: `${ROUTE.COURSE_MANAGEMENT}`,
		sub: [
			{
				title: 'Category New badge',
				href: `${ROUTE.COURSE_MANAGEMENT}${ROUTE.CATEGORY_NEW}`,
			},
			{
				title: 'Category Intro',
				href: `${ROUTE.COURSE_MANAGEMENT}${ROUTE.CATEGORY_INTRO}`,
			},
		],
	},
	{
		title: 'Email Content Management',
		icon: <MailOutlined />,
		href: `${ROUTE.EMAIL_CONTENT_MANAGEMENT}`,
		sub: [
			{
				title: 'Lists',
				href: `${ROUTE.EMAIL_CONTENT_MANAGEMENT}${ROUTE.LIST}`,
			},
			{
				title: 'Create',
				href: `${ROUTE.EMAIL_CONTENT_MANAGEMENT}${ROUTE.CREATE}`,
			},
			{
				title: 'Send',
				href: `${ROUTE.EMAIL_CONTENT_MANAGEMENT}${ROUTE.EMAIL_SEND}`,
			},
			{
				title: 'Send history',
				href: `${ROUTE.EMAIL_CONTENT_MANAGEMENT}${ROUTE.EMAIL_SEND_HISTORY}`,
			},
		],
	},
	{
		title: 'Blog Management',
		icon: <FileTextOutlined />,
		href: `${ROUTE.BLOG_MANAGEMENT}`,
		sub: [
			{
				title: 'Lists',
				href: `${ROUTE.BLOG_MANAGEMENT}${ROUTE.LIST}`,
			},
			{
				title: 'Create',
				href: `${ROUTE.BLOG_MANAGEMENT}${ROUTE.CREATE}`,
			},
		],
	},
	{
		title: 'i18n / Translations',
		icon: <GlobalOutlined />,
		href: `${ROUTE.I18N_MANAGEMENT}`,
		sub: [
			{
				title: 'Languages',
				href: `${ROUTE.I18N_MANAGEMENT}${ROUTE.I18N_LANGUAGES}`,
			},
			{
				title: 'Course translations',
				href: `${ROUTE.I18N_MANAGEMENT}${ROUTE.I18N_COURSES}`,
			},
		],
	},
	{
		title: 'Agents Management',
		icon: <RobotOutlined />,
		href: `${ROUTE.AGENTS_MANAGEMENT}`,
		sub: [
			{
				title: 'Product Owner',
				href: `${ROUTE.AGENTS_MANAGEMENT}${ROUTE.PRODUCT_OWNER}`,
			},
			{
				title: 'Content Marketing',
				href: `${ROUTE.AGENTS_MANAGEMENT}${ROUTE.CONTENT_MARKETING}`,
			},
			{
				title: 'Engineer',
				href: `${ROUTE.AGENTS_MANAGEMENT}${ROUTE.ENGINEER}`,
			},
			{
				title: 'Project Manager',
				href: `${ROUTE.AGENTS_MANAGEMENT}${ROUTE.PROJECT_MANAGER}`,
			},
			{
				title: 'Agent Configs',
				href: `${ROUTE.AGENTS_MANAGEMENT}${ROUTE.AGENT_CONFIGS}`,
			},
		],
	},
]
const SidebarComponent = () => {
	const [openKey, setOpenKey] = useState([])
	let history = useHistory()
	const linkToPage = href => {
		history.push(href)
	}
	const onTitleClick = href => {
		if (openKey.includes(href)) {
			let tmp = openKey.filter(item => !(href === item))
			setOpenKey(tmp)
		} else {
			let tmp = [...openKey, href]
			setOpenKey(tmp)
		}
	}
	useEffect(() => {
		const listenHistory = location => {
			let href = '/' + location.pathname.split('/')[1]
			if (!openKey.includes(href)) {
				let tmp = [...openKey, href]
				setOpenKey(tmp)
			}
		}
		return history.listen(listenHistory)
	}, [history, openKey])

	return (
		<div className="side-bar">
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={[history.location.pathname]}
				openKeys={openKey}
			>
				<Menu.Item className="logoWrapper">
					<img src={Logo} alt="WordsMine" className="logo" />
				</Menu.Item>
				<Menu.Item
					onClick={() => linkToPage(ROUTE.DASHBOARD)}
					icon={<HomeOutlined />}
				>
					Dashboard
				</Menu.Item>
				{MENU_ITEM.map(item => (
					<Menu.SubMenu
						key={`${item.href}`}
						icon={item.icon}
						title={item.title}
						onTitleClick={() => onTitleClick(item.href)}
					>
						{item.sub &&
							item.sub.map(subItem => (
								<Menu.Item
									key={`${subItem.href}`}
									onClick={() => linkToPage(subItem.href)}
								>
									{subItem.title}
								</Menu.Item>
							))}
					</Menu.SubMenu>
				))}
			</Menu>
		</div>
	)
}

export const Sidebar = SidebarComponent

SidebarComponent.propTypes = {
	history: PropTypes.object,
}
